import { render } from "./oldAreaDashboard.vue?vue&type=template&id=5c5b4f78&scoped=true"
import script from "./oldAreaDashboard.vue?vue&type=script&lang=js"
export * from "./oldAreaDashboard.vue?vue&type=script&lang=js"

import "./oldAreaDashboard.vue?vue&type=style&index=0&id=5c5b4f78&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5b4f78"]])

export default __exports__